import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M16 12v4', key: 'vf1vip' }],
  ['path', { d: 'M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2', key: 'llnzfg' }],
  [
    'path',
    {
      d: 'M17 6a2 2 0 011.414.586l3 3A2 2 0 0122 11v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 01.586-1.414l3-3A2 2 0 017 6z',
      key: '1hprxj',
    },
  ],
  ['path', { d: 'M2 14h20', key: 'myj16y' }],
  ['path', { d: 'M8 12v4', key: '1w4uao' }],
];

/**
 * @component @name Toolbox
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTJ2NCIgLz4KICA8cGF0aCBkPSJNMTYgNlY0YTIgMiAwIDAwLTItMmgtNGEyIDIgMCAwMC0yIDJ2MiIgLz4KICA8cGF0aCBkPSJNMTcgNmEyIDIgMCAwMTEuNDE0LjU4NmwzIDNBMiAyIDAgMDEyMiAxMXY4YTIgMiAwIDAxLTIgMkg0YTIgMiAwIDAxLTItMnYtOGEyIDIgMCAwMS41ODYtMS40MTRsMy0zQTIgMiAwIDAxNyA2eiIgLz4KICA8cGF0aCBkPSJNMiAxNGgyMCIgLz4KICA8cGF0aCBkPSJNOCAxMnY0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/toolbox
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Toolbox = createLucideIcon('toolbox', __iconNode);

export default Toolbox;
